module.exports = require("isbinaryfile");;